<template>
  <div id="my-account">
    <SfContentPages
      :title="$t('My Account')"
      :active="activePage"
      class="my-account"
      @click:change="changeActivePage"
    >
      <SfContentCategory :title="$t('Personal Details')">
        <SfContentPage :title="$t('My profile')">
          <OMyAccountProfile />
        </SfContentPage>
        <!-- <SfContentPage :title="$t('Shipping details')">
          <OMyAccountShippingDetails />
        </SfContentPage>
        <SfContentPage :title="$t('Loyalty Card')">
          <OMyAccountPlaceholder :title="$t('Loyalty Card')" />
        </SfContentPage>
        <SfContentPage :title="$t('My newsletter')">
          <OMyAccountPlaceholder :title="$t('My newsletter')" />
        </SfContentPage>
      </SfContentCategory>
      <SfContentCategory :title="$t('Order details')">
        <SfContentPage :title="$t('Order history')">
          <OMyAccountOrdersHistory />
        </SfContentPage>
        <SfContentPage :title="$t('My reviews')">
          <OMyAccountPlaceholder :title="$t('My reviews')" />
        </SfContentPage> -->
      </SfContentCategory>
      <SfContentPage :title="$t('Log out')" />
    </SfContentPages>
  </div>
</template>

<script>
import OMyAccountProfile from "@theme/components/organisms/o-my-account-profile";
// import OMyAccountShippingDetails from "@theme/components/organisms/o-my-account-shipping-details";
// import OMyAccountOrdersHistory from "@theme/components/organisms/o-my-account-orders-history";
// import OMyAccountPlaceholder from "@theme/components/organisms/o-my-account-placeholder";
import SfContentPages from "@lib/components/organisms/SfContentPages/SfContentPages";
import i18n from "@lib/i18n";
import { Logger } from "@lib/utility/logger";
import firebase from "@lib/firebase";

export default {
  components: {
    SfContentPages,
    OMyAccountProfile,
    // OMyAccountShippingDetails,
    // OMyAccountOrdersHistory,
    // OMyAccountPlaceholder,
  },
  props: {
    activeBlock: {
      type: String,
      default: "MyProfile",
    },
  },
  data() {
    return {
      navigation: [],
      returnEditMode: false,
      activePage: this.$t("My profile"),
    };
  },
  beforeMount() {
    this.$bus.$on("myAccount-before-updateUser", this.onBeforeUpdateUser);
    this.$bus.$on(
      "myAccount-before-changePassword",
      this.onBeforeChangePassword
    );
  },
  async mounted() {
    if (!this.$store.getters["user/isLoggedIn"]) {
      localStorage.setItem("redirect", this.$route.path);
      this.$router.push({
        name: "home",
        params: { storeId: this.$router.params.storeId },
      });
    }
  },
  destroyed() {
    this.$bus.$off("myAccount-before-updateUser", this.onBeforeUpdateUser);
    this.$bus.$off(
      "myAccount-before-changePassword",
      this.onBeforeChangePassword
    );
  },
  methods: {
    changeActivePage(title) {
      if (title === "Log out") {
        this.logout();
        return;
      }
      this.activePage = title;
    },
    async logout() {
      firebase.auth().signOut();
      this.$router.push({
        name: "home",
        params: { storeId: this.$route.params.storeId },
      });
      await this.$store.dispatch(
        "notification/spawnNotification",
        {
          type: "success",
          message: i18n.t("You're logged out"),
          action1: { label: i18n.t("OK") },
        },
        { root: true }
      );
    },
    onBeforeChangePassword(passwordData) {
      this.$store.dispatch("user/changePassword", passwordData);
    },
    onBeforeUpdateUser(updatedData) {
      if (updatedData) {
        try {
          this.$store.dispatch("user/update", { customer: updatedData });
        } catch (err) {
          this.$bus.$emit(
            "myAccount-before-remainInEditMode",
            this.$props.activeBlock
          );
          Logger.error(err)();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@lib/styles/helpers/breakpoints";

#my-account {
  box-sizing: border-box;
  @include for-desktop {
    max-width: 1272px;
    padding: 0 var(--spacer-sm);
    margin: 0 auto;
  }
}
.my-account {
  --content-pages-height: auto;
  ::v-deep {
    .sf-content-pages__content,
    .sf-content-pages__sidebar {
      height: min-content;
    }
  }
  @include for-mobile {
    --content-pages-sidebar-category-title-font-weight: var(--font-normal);
    --content-pages-sidebar-category-title-margin: var(--spacer-sm)
      var(--spacer-sm) var(--spacer-sm) var(--spacer-base);
  }
  @include for-desktop {
    --content-pages-sidebar-category-title-margin: var(--spacer-xl) 0 0 0;
  }
}
.breadcrumbs {
  padding: var(--spacer-base) 0;
}
</style>
